import * as React from 'react';
type Props = {
  className?: string;
};
export function Bison({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Bison"
      className={className}
    >
      <path
        d="M18.0199 46.8179C15.7382 46.8707 13.3529 45.9645 11.4625 44.4581C6.89387 40.8175 5.65689 34.9509 6.79113 30.0189C7.846 25.4316 14.3342 19.9102 18.3586 17.7189C22.8874 15.253 33.5051 8.74662 31.1297 12.1405C24.7007 21.3262 28.9864 34.9277 28.8881 36.4225C28.7303 38.8229 27.3001 40.8664 25.8137 42.5726C23.8935 44.7767 21.3396 46.6554 18.2337 46.81C18.1625 46.8136 18.0912 46.8162 18.0199 46.8179Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.2361 38.9778L30.2437 35.9013C30.801 34.9804 30.8001 33.61 30.618 32.4169C30.0746 28.8568 29.3071 20.746 32.5292 15.8013C34.7376 12.4122 38.57 9.46616 42.7951 5.82866C43.0877 5.57691 43.0183 5.07291 42.6451 4.76089L41.5247 3.82436C41.2108 3.56202 40.7916 3.52691 40.5496 3.74271L31.1298 12.1405"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6653 38.53C20.6653 38.53 16.2823 42.467 12.8172 38.0357C10.6474 35.261 10.6907 31.2683 12.7121 28.2713C13.9756 26.3978 15.8526 24.4337 18.5338 23.366"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1579 17.9731C23.6822 19.8891 22.8717 23.8729 23.2247 27.8213"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
